// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"246":"bb389b56","875":"9dfacc73","4587":"c7118d6b"}[chunkId] || chunkId) + "." + {"246":"76f0f59bf64e78c8","875":"1cb03d5d503b9853","2311":"9558129e8c268de1","4587":"0f8139e6089dd2b5","5193":"2f90c0cb45238458","6446":"38b8d9d562a699cf","7297":"0a680ac95bd728b3"}[chunkId] + ".js";
};